import React from "react";

interface TableHeader {
  title: string;
  dataIndex: string;
  align?: string;
  width?: number; // Optional width property
  withBorder?: boolean;
  render?: (text: any, record: any, index: number) => React.ReactNode;
}

interface PlainTableProps {
  headers: TableHeader[];
  rows: { [key: string]: any }[];
  withHeader?: boolean;
  withBorder?: boolean;
  coloredHeader?: boolean;
}

const PlainTable: React.FC<PlainTableProps> = ({
  headers,
  rows,
  withHeader = true,
  withBorder = true,
  coloredHeader = true,
}) => {
  return (
    <table className="w-full border-collapse">
      {withHeader && (
        <thead className={`${coloredHeader && `bg-primary`}`}>
          <tr>
            {/* Render table headers dynamically */}
            {headers?.map((header, index) => (
              <th
                key={index}
                className={`${withBorder ? `table-cell-border` : ``} ${
                  header.align ?? ""
                }`}
                style={{
                  width: header.width || "auto", // Apply specified width or auto if not provided
                }}
              >
                <span
                  className={`${
                    coloredHeader ? `text-white` : `text-textColor`
                  }`}
                >
                  {header.title}
                </span>
              </th>
            ))}
          </tr>
        </thead>
      )}

      <tbody>
        {rows?.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {headers?.map((header, cellIndex) => (
              <td
                key={cellIndex}
                className={`${withBorder ? `table-cell-border` : ``} ${
                  header.align ?? ""
                }`}
                style={{
                  width: header.width || "auto", // Match the width of the header
                }}
              >
                {/* Check for a custom render function */}
                {header.render
                  ? header.render(row[header.dataIndex], row, rowIndex)
                  : row[header.dataIndex]}
              </td>
            ))}
          </tr>
        ))}
        {rows?.length === 0 && (
          <tr>
            <td
              colSpan={headers.length}
              className={`text-center ${
                withBorder ? `table-cell-border` : ``
              } py-5`}
            >
              No Data
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PlainTable;
